import type { PositionMarkerProps } from "./position-marker.type";

import Icon from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import MarkerSvg from "./svg/marker.svg?react";

import "./position-marker.style.less";

const PositionMarker = ({ position }: PositionMarkerProps) => {
  const { t } = useTranslation();
  return (
    <div
      className="position-marker-wrapper"
      data-testid="position-marker"
      style={position}
    >
      <Icon component={MarkerSvg} aria-label={t("global:marker")} />
    </div>
  );
};

export default PositionMarker;
